/**
 * 앱 다운받기 (앱이 있는 경우 앱 열기)
 * @param url  string (https://~)
 */

import { getUA, isAndroid, isIOS } from 'react-device-detect';
import { IS_MARTGO_APP } from './constants';
import { TLeafletList } from 'src/types/types';
import moment from 'moment';

export const appStoreMove = _url => {
  const url = encodeURIComponent(_url);
  if (!IS_MARTGO_APP) {
    try {
      //앱 열기
      if (isIOS) {
        window.location.href =
          getUA.indexOf('mcoupon') > -1
            ? url
            : 'lottemart-mcoupon-iphone://?url=' + url;
      } else if (isAndroid) {
        const browser = getUA.toLowerCase();

        if (
          parseFloat(browser.substring(browser.indexOf('android') + 8)) >= 4.4
        ) {
          window.location.href =
            'intent://m.coupon.lottemart?url=' +
            url +
            '#Intent;scheme=lmscp;action=android.intent.action.VIEW;category=android.intent.category.BROWSABLE;package=com.lottemart.lmscp;end';
        } else {
          window.location.href = 'lmscp://m.coupon.lottemart?url=' + url;
          setTimeout(function () {
            window.location.href = 'market://details?id=com.lottemart.lmscp';
          }, 300);
        }
      }
    } catch (e) {
      //오류 시 스토어
      if (isIOS) {
        window.location.href = 'https://itunes.apple.com/app/id987435592';
      } else {
        window.location.href = 'market://details?id=com.lottemart.lmscp';
      }
    }
  }
};

/**
 * @name 날짜 최소값 추출
 * @param leaflet_list 전단 목록
 * @description 조건에 맞는 전단이 여러개인 경우 기간 비교 후, 짧은 기준으로 추출
 */
export const getMinDateLeaflet = (
  leaflet_list: TLeafletList[],
): TLeafletList => {
  const minDateLeaflet = leaflet_list.map(leaflet => {
    const startDt = moment(leaflet.post_start_dt, 'YYYY-MM-DD HH:mm:ss');
    const endDt = moment(leaflet.post_end_dt, 'YYYY-MM-DD HH:mm:ss');
    return moment.duration(endDt.diff(startDt)).asDays();
  });

  const minIndex = minDateLeaflet.findIndex(
    leaflet => leaflet === Math.min(...minDateLeaflet),
  );

  return leaflet_list[minIndex];
};

/**
 * @name 전단 url 추출
 */
export const changeLeafletUrl = (url: string): string => {
  // "mlotte.net/leaflet" 패턴을 찾습니다.
  // 이 패턴은 URL의 호스트 부분 다음에 바로 경로가 시작되는 것을 가정합니다.
  // 예: https://www.mlotte.net/leaflet... 또는 http://mlotte.net/leaflet...
  const combinedPattern = 'mlotte.net/leaflet';
  const leafletPathMarker = '/leaflet';

  const patternStartIndex = url.indexOf(combinedPattern);

  if (patternStartIndex !== -1) {
    // "mlotte.net/leaflet" 패턴을 찾은 경우,
    // 패턴 내에서 "/leaflet"의 시작 위치를 찾습니다.
    const pathStartIndexInPattern = combinedPattern.indexOf(leafletPathMarker);
    // 원본 URL에서 "/leaflet"부터 시작하는 경로를 추출합니다.
    return url.substring(patternStartIndex + pathStartIndexInPattern);
  }

  // URL이 지정된 패턴과 일치하지 않으면 빈 문자열을 반환합니다.
  return '';
};
